<template>
  <div>
    <span id="disabled-wrapper-sangria">
      <b-button v-b-modal.modal-sangria-caixa
                class="w-100 mt-3"
                variant="warning"
                :disabled="caixa.aberto === 0">
        Sangria de Caixa
      </b-button>
    </span>
    <b-tooltip v-if="caixa.aberto === 0"
               target="disabled-wrapper-sangria"
               triggers="hover">
      É necessário abrir o caixa para poder criar lançamentos
    </b-tooltip>
    <b-modal id="modal-sangria-caixa"
             centered
             title="Sangria de caixa"
             header-bg-variant="secondary"
             header-text-variant="white">
      <div>
        <!-- Tipo -->
        <RadioGlobal :prop-optins="options"
                     prop-label="Tipo"
                     prop-data-propriedade="tipo"
                     :prop-required="true"
                     @setInputValue="setInputValue" />
        <!-- Valor -->
        <InputGlobal prop-label="Valor"
                     prop-type="text"
                     prop-data-propriedade="valor"
                     prop-validate="dinheiro"
                     prop-error-mensage="O Valor deve ser maior que R$ 0,00"
                     :prop-required="true"
                     :prop-money="true"
                     @setInputValue="setInputValue" />
      </div>
      <template #modal-footer="{close}">
        <div class="w-100 d-flex justify-content-end">
          <b-button class="pl-4 pr-4"
                    @click="close()">
            Voltar
          </b-button>
          <b-button class="ml-5 pl-4 pr-4"
                    @click="saveForm">
            Salvar
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>

  // Inputs
  import InputGlobal from '../../../../components/Input/InputGlobal.vue'
  import RadioGlobal from '../../../../components/Input/RadioGlobal.vue'

  // Service
  import lancamentoService from '../lancamentoService'
  import pedidoService from '../pedidoService'

  // Outros
  import moment from 'moment'
  import pagamentoService from '../pagamentoService'

  export default {
    name: "SangriaCaixa",
    components: { InputGlobal, RadioGlobal },
    data () {
      return {
        form: {
          tipo: null,
          valor: null,
          caixaId: null,
        },
        options: [
          { text: 'Entrada', value: 'receita' },
          { text: 'Saída', value: 'despesa' },
        ]
      }
    },
    computed: {
      cxData () {
        return this.$store.state.frenteCaixa.cxData
      },
      caixa () {
        return this.$store.state.frenteCaixa.caixa
      },
      cxSaldo () {
        return this.$store.state.frenteCaixa.saldo
      },
    },
    watch: {
      caixa () {
        this.form.caixaId = this.caixa.caixa_id
      }
    },
    async created  () {
      this.form.caixaId = this.caixa.caixa_id
    },
    methods: {
      setInputValue (value, propriedade) {
        this.form[propriedade] = value
      },
      async saveForm () {
        if (!this.form.tipo || !this.form.valor) {
          return displayMessage('error', 'Error!', 'O tipo e o valor do lançamento são obrigatórios')
        }

        if (this.cxSaldo.pedidos.saldoTotal < this.form.valor && this.form.tipo === 'despesa') return displayMessage('error', 'Error!', 'O Valor da sangria não pode ser maior que o saldo Atual')
        try {
          if (this.form.tipo === 'receita') {
            const pedidoPayload = {
              caixa_id: this.caixa.caixa_id,
              data_lancamento: moment(this.caixa.data_abertura).format('YYYY-MM-DD'),
              tipo_pedido: 'Avulso',
              solicitante: 'Sangria de caixa',
              status_pg: 'concluido',
            }
            const pedido = await pedidoService.storePedido(pedidoPayload)

            const lancamentoPayload = {
              data_lancamento: moment(this.caixa.data_abertura).format('YYYY-MM-DD'),
              tipo_lancamento: this.form.tipo,
              beneficiario: 'Sangria de caixa',
              valor_total: this.form.valor,
              status_pg: 'concluido',
              id_pedido: pedido.cx_pedido_id,
              caixaId: this.caixa.caixa_id,
              sangria_caixa: true,
            }
            const lancamento = await lancamentoService.storeLancamento(lancamentoPayload)

            const pagamento = {
              tipo: 'Sangria: entrada',
              qt_parcelas: "1",
              id_pedido: pedido.cx_pedido_id,
              itens: []
            }
            pagamento.itens.push({
              valor: this.form.valor,
              forma_pagamento: '---',
              parcela: {
                total: 1,
                atual: 1,
              }
            })
            await pagamentoService.storePagamento(pagamento)
          } else {
            const lancamentoPayload = {
              data_lancamento: moment(this.caixa.data_abertura).format('YYYY-MM-DD'),
              tipo_lancamento: this.form.tipo,
              beneficiario: 'Sangria de caixa',
              valor_total: this.form.valor,
              status_pg: 'concluido',
              id_pedido: null,
              caixaId: this.caixa.caixa_id,
              sangria_caixa: true,
            }
            const lancamento = await lancamentoService.storeLancamento(lancamentoPayload)            
          }
          this.$bvModal.hide('modal-sangria-caixa')
          // Atualiza tabela
          this.$store.dispatch('frenteCaixa/atualizarPedidos')   
          displayMessage('success', 'success!', 'Sangria criada com sucesso')
        } catch (error) {
          const message = getErrors(error)
          displayMessage('error', 'Erro!', message.message)
        }
      }
    }
  }
</script>

<style scope>

</style>